import { render, staticRenderFns } from "./Imprime.vue?vue&type=template&id=50c230c8&"
import script from "./Imprime.vue?vue&type=script&lang=js&"
export * from "./Imprime.vue?vue&type=script&lang=js&"
import style0 from "./Imprime.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VOverlay,VProgressCircular,VSimpleTable})
